import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export interface DocLinkCardProps {
  icon: string;
  title: string;
  url: string | null;
  openLabel: string;
  emptyLabel: string;
  /** Show a QR code next to the link so the document can be opened on a phone. */
  qr?: boolean;
  qrLabel?: string;
}

export function DocLinkCard({ icon, title, url, openLabel, emptyLabel, qr = false, qrLabel }: DocLinkCardProps) {
  const [qrSrc, setQrSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!qr || !url) { setQrSrc(null); return; }
    void QRCode.toDataURL(url, { margin: 1, width: 160 })
      .then(setQrSrc)
      .catch(() => setQrSrc(null));
  }, [qr, url]);

  if (!url) {
    return (
      <div className="doc-card doc-card-empty">
        <span className="doc-icon" aria-hidden="true">{icon}</span>
        <p>{emptyLabel}</p>
      </div>
    );
  }

  return (
    <div className="doc-card">
      <div className="doc-text">
        <span className="doc-icon" aria-hidden="true">{icon}</span>
        <div>
          <h2>{title}</h2>
          <a className="doc-link" href={url} target="_blank" rel="noreferrer">
            {openLabel} ↗
          </a>
        </div>
      </div>
      {qrSrc && qrLabel && (
        <div className="doc-qr">
          <img src={qrSrc} alt={qrLabel} width={120} height={120} />
          <span>{qrLabel}</span>
        </div>
      )}
    </div>
  );
}
